import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import { useBootstrapPrefix } from './ThemeProvider';
import { useCol } from './Col';
export default function usePlaceholder(_ref) {
  var animation = _ref.animation,
    bg = _ref.bg,
    bsPrefix = _ref.bsPrefix,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, ["animation", "bg", "bsPrefix", "size"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'placeholder');
  var _useCol = useCol(props),
    _useCol2 = _slicedToArray(_useCol, 1),
    _useCol2$ = _useCol2[0],
    className = _useCol2$.className,
    colProps = _objectWithoutProperties(_useCol2$, ["className"]);
  return _objectSpread({}, colProps, {
    className: classNames(className, animation ? "".concat(bsPrefix, "-").concat(animation) : bsPrefix, size && "".concat(bsPrefix, "-").concat(size), bg && "bg-".concat(bg))
  });
}